import graphql from 'babel-plugin-relay/macro'
import { truncate } from 'lodash'
import md5 from 'md5'
import moment from 'moment'
import React, { Component } from 'react'
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs
} from 'react-google-maps'
import { createFragmentContainer } from 'react-relay'
import { compose } from 'recompose'
import styled from 'styled-components'

import config from '../../config'

const formattedDateAt = (dateAt, formatString) =>
  moment(dateAt).format(formatString)

const MapWithAMarker = compose(
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    defaultZoom={14}
    defaultCenter={{ lat: props.latitude, lng: props.longitude }}
  >
    <Marker position={{ lat: props.latitude, lng: props.longitude }} />
  </GoogleMap>
))

const Container = styled.div`
  flex: 3;
  display: flex;
  flex-direction: row;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #fcfcfc;
`

const InnerContainer = styled.div`
  flex: 3;
  margin-left: 8px;
`

const SenderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Sender = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;
  flex: 1;
`

const TimestampContainer = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 0.8em;
  color: gray;
  flex-direction: row;
  justify-content: flex-end;
`

const BodyContainer = styled.div`
  flex: 1;
`

const Avatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-size: 32px 32px;
  float: left;
  margin-top: 4px;
`

class MessageRow extends Component {
  findHtmlOverTextPart = parts =>
    parts.find(p => p.mimeType === 'text/html') ||
    parts.find(p => p.mimeType === 'text/plain')

  withoutHtmlTextFilter = part =>
    part.mimeType !== 'text/html' && part.mimeType !== 'text/plain'

  renderPictureUrl = ({ id, pictureUrl }) => {
    let imageUrl

    if (pictureUrl) {
      // imageUrl = `https://${config.imgixHost}/${pictureUrl.substr(pictureUrl.lastIndexOf('/') + 1)}?w=32&h=32&fit=crop&mask=ellipse&dpr=2&fm=png32`
      imageUrl = `https://${config.cloudimageHost}/${pictureUrl.substr(
        pictureUrl.lastIndexOf('/') + 1
      )}?width=32&height=32&func=crop&optipress=3`
    } else if (id) {
      imageUrl = `${config.apiUrl}/avatar/${md5(id.trim().toLowerCase())}?s=64`
    }

    return <Avatar style={{ backgroundImage: `url(${imageUrl})` }} />
  }

  renderName = ({ name, firstName, lastName, phone, email }) =>
    name || firstName || lastName || phone || email

  renderDisplayName = () => {
    const {
      message: { user, family, contact, sender }
    } = this.props

    return (
      <Sender>
        {this.renderName(user || family || contact || {}) ||
          (sender && sender.displayName) ||
          'Anonymous'}
      </Sender>
    )
  }

  // basename = url => url ? url.substr(url.lastIndexOf('/') + 1) : ''
  basename = url => (url ? url.replace(/http?s:\/\/[^/]*\//, '') : '')

  renderPartNode = part => {
    switch (part.mimeType) {
      case 'text/plain':
        return part.body

      case 'text/markdown':
        return <div dangerouslySetInnerHTML={{ __html: part.formattedBody }} />

      case 'text/html':
        return (
          <iframe
            title='internal-message'
            src={`${config.appUrl}/parts/${part.id}`}
            style={{ width: '100%', border: 'none' }}
          ></iframe>
        )

      case 'familio/event':
      case 'application/vnd.familio.event':
        break
      // return <EventPart eventId={part.contentUrl} body={part.bodyExcerpt} onPress={() => this.onEventPressed(part.contentUrl)} />

      case 'application/vnd.familio.voice':
        break
      // return <VoicePart content={part.content} />

      case 'application/vnd.familio.message':
        break
      // return <MessagePart content={part.content} navigation={this.props.navigation} />

      case 'application/vnd.familio.action':
        const photoUrl = part.content.photoUrl
        // ? imageResizerUrl(part.content.photoUrl, { width: 72, height: 72, fit: 'crop', dpr: 2 })
        // : null

        return (
          <div
            direction={{ base: 'column', sm: 'row' }}
            overflow='hidden'
            variant='outline'
            cursor='pointer'
          >
            <img
              objectFit='cover'
              w='72px'
              h='72px'
              borderRadius='4px'
              overflow='hidden'
              m={2}
              src={photoUrl}
              alt={part.content.name || ''}
            />
            <h3>{part.content.name}</h3>
            <p color='fg-muted' fontSize='sm'>
              {truncate(part.content.description || '', { length: 128 })}
            </p>
          </div>
        )
      case 'application/vnd.familio.photo':
      case 'image/jpeg':
      case 'image/png':
      case 'image/gif':
        // return <a href={part.contentUrl} rel='noopener noreferrer' target='_blank'><img src={`https://${config.imgixHost}/${this.basename(part.contentUrl)}?w=320&fit=crop&auto=compress,enhance,format`} alt={part.bodyExcerpt} style={{ borderRadius: 4, maxWidth: '100%' }} /></a>
        return (
          <a href={part.contentUrl} rel='noopener noreferrer' target='_blank'>
            <img
              src={`https://${config.cloudimageHost}/${this.basename(
                part.contentUrl
              )}?width=480&func=crop&gravity=smart&force_format=webp,jpeg&optipress=1`}
              alt={part.bodyExcerpt}
              style={{
                borderRadius: 4,
                maxWidth: '100%'
              }}
            />
          </a>
        )

      case 'application/vnd.familio.video':
        // return <VideoPart body={part.bodyExcerpt} url={part.contentUrl} />
        // return <a href={part.contentUrl} rel='noopener noreferrer' target='_blank'>{part.bodyExcerpt}</a>
        return (
          <>
            <a href={part.contentUrl} rel='noreferrer' target='_blank'>
              Link to video
            </a>
            <div
              style={{
                borderRadius: '4px',
                overflow: 'hidden',
                width: 480,
                height: 480
              }}
            >
              <iframe
                title={part.id}
                frameBorder='0'
                allowFullScreen=''
                src={`https://onelineplayer.com/player.html?autoplay=false&loop=false&autopause=true&muted=true&url=${encodeURI(
                  part.contentUrl
                )}&poster=&time=true&progressBar=true&playButton=true&overlay=true&muteButton=true&fullscreenButton=true&style=light&logo=false&quality=1080p`}
                scrolling='no'
                width='480'
                height='480'
              />
            </div>
          </>
        )

      case 'application/vnd.familio.location': {
        // return <LocationPart content={part.content} onPress={() => this.onLocationPressed(part.content)} />
        return (
          <MapWithAMarker
            longitude={part.content.longitude}
            latitude={part.content.latitude}
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${config.googleApiKey}`}
            loadingElement={<div style={{ height: '100%' }} />}
            containerElement={<div style={{ height: '160px' }} />}
            mapElement={<div style={{ borderRadius: 4, height: '100%' }} />}
          />
        )
      }

      case 'familio/attachment':
        break
      // return <AttachmentPart title={part.bodyExcerpt} onPress={() => this.onAttachmentPressed(part)} />

      case 'text/x-vcard':
        break
      // return <VcfPart title={part.bodyExcerpt} onPress={() => this.onAttachmentPressed(part)} />

      case 'application/pdf':
        break
      // return <PdfPart title={part.bodyExcerpt} url={part.contentUrl} onPress={() => this.onAttachmentPressed(part)} />

      default:
        break
      // return <AttachmentPart title={part.bodyExcerpt} url={part.contentUrl} onPress={() => this.onAttachmentPressed(part)} />
    }
  }

  renderPart = part => this.renderPartNode(part)

  renderHeadPart = headPart => {
    if (!headPart) return null

    return <div key={headPart.id}>{this.renderPart(headPart)}</div>
  }

  renderTailParts = tailParts => {
    return (
      <div>
        {tailParts.map(part => (
          <div key={part.id}>{this.renderPart(part)}</div>
        ))}
      </div>
    )
  }

  renderParts = partEdges => {
    const parts = partEdges.map(edge => edge.node)
    return this.renderTailParts(parts)

    // const headPart = this.findHtmlOverTextPart(parts)
    // const tailParts = parts.filter(this.withoutHtmlTextFilter)

    // return (
    //   <div>
    //     {this.renderHeadPart(headPart)}
    //     {this.renderTailParts(tailParts)}
    //   </div>
    // )
  }

  renderTimestamp = () => {
    const {
      message: { createdAt }
    } = this.props

    return (
      <TimestampContainer>
        {formattedDateAt(createdAt, 'MMM D LT')}
      </TimestampContainer>
    )
  }

  render () {
    const {
      message: { user, family, contact, parts }
    } = this.props

    return (
      <Container>
        {this.renderPictureUrl(user || family || contact || {})}
        <InnerContainer>
          <SenderContainer>
            {this.renderDisplayName()}
            {this.renderTimestamp()}
          </SenderContainer>
          <BodyContainer>{this.renderParts(parts.edges)}</BodyContainer>
        </InnerContainer>
      </Container>
    )
  }
}

const MessageRowContainer = createFragmentContainer(MessageRow, {
  message: graphql`
    fragment MessageRow_message on Message {
      id
      userId
      bodyExcerpt
      createdAt
      sender
      user: userByUserId {
        id
        pictureUrl
        name
        firstName
        lastName
        email
        phone
      }
      family: familyByFamilyId {
        id
        name
      }
      contact: contactByContactId {
        id
        pictureUrl
        firstName
        lastName
        email
        phone
      }
      partner: partnerByPartnerId {
        id
        name
      }
      parts: partsByMessageId(first: 666) @connection(key: "Messages_parts") {
        edges {
          node {
            id
            order
            mimeType
            body
            bodyExcerpt
            formattedBody
            contentUrl
            content
          }
        }
      }
    }
  `
})

export { MessageRowContainer as MessageRow }
